"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Card_1 = require("./Card");
exports.AdsManagerAdBrochureSalesMaterials = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.AdsManagerBrochureCard, { title: "Sales Materials", description: "Manage, generate, and create custom sell sheets, collateral, and marketing materials for newsletters." },
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "show" }, "Create 1:1 mock email sends for ready-made, production quality collateral."),
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "analytics" }, "Quickly reference, and organize the critical numbers you use for sales purposes."))));
};
//# sourceMappingURL=AdSalesMaterials.js.map